module.exports = __webpack_public_path__ + "static/media/icon_131.252a962c.svg";